import axios from 'axios';
import { baseUrl } from './apis';
import LogOutUser from '../helper/logout';
import { Dimensions, Platform } from 'react-native';
import { getUniqueDeviceId, isCookieExpirated, isIframeCheck, trackEvent } from '@app/utils';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { encrypt,decrypt,isEncrypted } from '@app/utils';
import {store} from '../store/newstore'
import { showErrorSheet } from '@app/store/slices/errorSlice';
const InterceptorSetup = () => {
  // Request interceptor
  axios.interceptors.request.use(
    async req => {
      if ((req.method === 'post' || req.method === 'patch' || req.method === 'put') && req.data && isEncrypted(baseUrl)) {
        req.data = {encryptedRequest:await encrypt(JSON.stringify(req.data))}; // Encrypt the request data
      }
      req.url = baseUrl + req.url;
      req.headers['X-EntityType'] = 'BORROWER';
      req.headers['X-Appmode'] = 'INVESTOR_VIEW';
      req.headers['X-Deviceid'] =  Platform.OS === 'web' ? '' : getUniqueDeviceId();
      req.headers['Content-Type'] = 'application/json';
      req.headers['Encryption'] =  isEncrypted(baseUrl);
      req.headers['X-DeviceType'] = Platform.OS === 'web' ? Dimensions.get('screen').width > 767 ? 'Desktop' :'Mobile':'Mobile';
      if(!req.headers['X-AppPlatform']){
        req.headers['X-AppPlatform'] = 'VOLT_WEB_APP';
      }
      if(!req.headers['Authorization']){
        if(Platform.OS === 'web'){
          const isAccessTokenInCookiPreset = document.cookie.split(';').some((item) => item.trim().startsWith('access_token='));
          if(isAccessTokenInCookiPreset){
            const accessTokenCookie = document.cookie.split(';').find((item) => item.trim().startsWith('access_token='));
            const accessToken = accessTokenCookie?.split('=')[1];
            accessToken ? req.headers['Authorization'] = 'Bearer ' + accessToken: null
          }
          if(!isAccessTokenInCookiPreset && isIframeCheck()){
            const accessToken = await AsyncStorage.getItem('access_token');
            accessToken ? req.headers['Authorization'] = 'Bearer ' + accessToken: null
          }
        }
        else{
          const token = await AsyncStorage.getItem('access_token'); // get token from async storage
          token ? req.headers['Authorization'] = 'Bearer ' + token: null
        }
      }
      if(Platform.OS === 'web') {
        if(!navigator.onLine) {
           store.dispatch(showErrorSheet(
            {
              isErrorSheetVisible: true,
              errorMessage: 'Network Error',
              closeOnBackdropPress: true,
              errorType: 'NO Internet',
            }
           ))
        }
      }
      return req;
    },
    err => {
      console.error('Request error:', err);
      return Promise.reject(err);
    },
  );

  // Response interceptor
  axios.interceptors.response.use(
    async res => {
      if (isEncrypted(baseUrl)) {
        const decryptedData = await decrypt(res?.data?.result); // DEncrypt the response data
        if(decryptedData!=="Logout successful" ){
          res.data = JSON.parse(decryptedData); // DEncrypt the response data
        }else{
          res.data = decryptedData; // DEncrypt the response data
        }// DEncrypt the response data
      }
      // Handle successful responses
      if (res.status === 200) {
        // console.log('Request successful');
      } else if (res.status === 201) {
        // console.log('Resource created successfully');
      }
      return res;
    },
   async  err => {
      let { response } = err;
      if (isEncrypted(baseUrl)) {
        const decryptedData = await decrypt(response?.data?.result); // DEncrypt the response data
        if(decryptedData!=="Logout successful" ){
          response.data = JSON.parse(decryptedData); // DEncrypt the response data
        }else{
          response.data = decryptedData; // DEncrypt the response data
        }
      }
      let isCookiesExpired =  false 

      if (Platform.OS === 'web') {
        isCookiesExpired = isCookieExpirated();
      }

      if (response) {
        // Handle specific status codes
        if (response?.status === 401 || response?.status === 403 || isCookiesExpired ) {
          trackEvent('NEW_ARCH_INTERCEPTOR_LOGOUT_TRIGERRED',{error:JSON.stringify(response)})
          LogOutUser();
        } else if (response?.status === 400 || response?.status === 500) {
          console.error('Error message:', response.data);
        }
        return Promise.reject(response);
      } else {
        // Handle network or other errors
        console.error('Network or other error:', err);
        return Promise.reject(err);
      }
    },
  );
};

export default InterceptorSetup;